import { RootState } from '@/models/root-state.model';
import { BffCmsFaqResponse } from '@lucky7ventures/bff-types';
import { createSelector } from 'reselect';

const selectFaq = (state: RootState): BffCmsFaqResponse => state.faq.faq;
export const selectFaqLoading = (state: RootState): boolean => state.faq.loading;
export const selectHomeFaq = createSelector(selectFaq, faq => faq.home);
export const selectDrawerFaq = createSelector(selectFaq, faq => faq.drawer);
